export default __webpack_public_path__ + "static/media/AboutHeader.e79315a2.jpg";